import React from 'react'
import { useCallback } from 'sb-hooks'
import { Field, useFieldState } from 'formular'

import EmailSuggestion, { EmailSuggestionProps } from '../EmailSuggestion/EmailSuggestion'


type FormularEmailSuggestionProps = Pick<EmailSuggestionProps, 'onConfirm'> & {
  field: Field<string>
}

const FormularEmailSuggestion: React.FunctionComponent<FormularEmailSuggestionProps> = (props) => {
  const { field, onConfirm } = props
  const { value } = useFieldState(field)

  const handleConfirm = useCallback((suggestion: string) => {
    field.set(suggestion)
    // run validation to remove error
    field.validate()

    if (typeof onConfirm === 'function') {
      onConfirm(suggestion)
    }
  }, [ field, onConfirm ])

  return (
    <EmailSuggestion email={value} onConfirm={handleConfirm} />
  )
}


export default FormularEmailSuggestion
